import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { modalClose } from '@app/store/modal/actions';

import { BasicModal } from '../../components/Modal';

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  onClose: PropTypes.func,
};

const defaultProps = {
  onClose() {},
};

class ParticipantProcessingFailedModal extends Component {
  constructor(props) {
    super(props);
    this.handleCancel = this.handleCancel.bind(this);
  }

  handleCancel() {
    const { history, onClose } = this.props;
    history.push('/');
    onClose();
  }

  handleClose() {
    const { onClose } = this.props;
    onClose();
  }

  render() {
    return (
      <BasicModal
        cancelText="홈으로"
        closeButtonClassName="tagContactButton"
        closeText="문의 남기기"
        content={
          '알 수 없는 오류로 문서 처리가 실패되었습니다.\n빠른 해결을 위해 이메일 주소와 문서 이름을\n온라인 문의로 남겨주세요.'
        }
        title="문서 처리 실패"
        onCancel={this.handleCancel}
        onClose={this.handleClose}
      />
    );
  }
}

ParticipantProcessingFailedModal.propTypes = propTypes;
ParticipantProcessingFailedModal.defaultProps = defaultProps;

const mapDispatchToProps = {
  onClose: modalClose,
};

export default withRouter(connect(null, mapDispatchToProps)(ParticipantProcessingFailedModal));
